'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bolt';
var width = 512;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = ['M44.2 272l196 0-7.4 21.3-70.5 201.4 305.6-254.7-196 0 7.4-21.3 70.5-201.4-305.6 254.7z', 'M300 208L373.7-2.6 384-32 360.1-12.1 19.2 272 0 288 217.6 288 212 304 138.3 514.6 128 544 151.9 524.1 492.8 240 512 224 294.4 224 300 208zm167.8 32l-305.6 254.7 70.5-201.4 7.4-21.3-196 0 305.6-254.7-70.5 201.4-7.4 21.3 196 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;